import { Link } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";
import PublicHeader from "@/components/PublicHeader";

export default function NotFound() {
    return (
        <div className="min-h-screen">
            <PublicHeader />
            <section className="pt-32 pb-24 px-6 sm:px-8 text-center">
                <p className="text-8xl sm:text-9xl font-semibold tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-[#007AFF] to-[#34C759]">
                    404
                </p>
                <h1 className="mt-6 text-3xl sm:text-4xl font-semibold tracking-tight text-[#1D1D1F]">
                    Cette page n&apos;existe pas.
                </h1>
                <p className="mt-3 text-[#86868B] max-w-md mx-auto">
                    Le lien est peut-être obsolète ou contient une faute. Aucun ticket n&apos;a été perdu.
                </p>
                <div className="mt-8 flex justify-center gap-3 flex-wrap">
                    <Link to="/accueil" className="tk-btn tk-btn-primary">
                        <Home className="w-4 h-4" /> Retour à l&apos;accueil
                    </Link>
                    <button
                        onClick={() => window.history.back()}
                        className="tk-btn tk-btn-secondary"
                    >
                        <ArrowLeft className="w-4 h-4" /> Page précédente
                    </button>
                </div>
            </section>
        </div>
    );
}
